export default __webpack_public_path__ + "static/media/laundry1-afterA.bef2862e.jpg";